import { Modal, ModalBody, ModalFooter } from "flowbite-react"
import { NavArrowRight, Phone } from "iconoir-react"
import { useNavigate } from "react-router-dom"

export default function NewerCallAvailableModal({
  show,
  setShow,
  newerCallId,
  onStay
}: {
  show: boolean
  setShow: (show: boolean) => void
  newerCallId: number | null
  onStay?: () => void
}) {
  const navigate = useNavigate()

  const handleClose = () => {
    setShow(false)
    if (onStay) {
      onStay()
    }
  }

  const handleNavigate = () => {
    if (newerCallId) {
      navigate(`/calls/${newerCallId}`)
    }
    setShow(false)
  }

  if (!show || !newerCallId) {
    return null
  }

  return (
    <Modal show={show} onClose={handleClose} size="lg" className="pt-safe">
      <ModalBody className="p-0">
        <div className="flex flex-col">
          <div className="bg-linear-to-r from-blue-600 to-purple-600 text-white p-8 rounded-t-lg">
            <div className="flex items-center justify-center mb-4">
              <div className="bg-white/20 p-3 rounded-full">
                <Phone className="w-8 h-8" />
              </div>
            </div>
            <h2 className="text-3xl font-bold text-center mb-2">A Newer Call is Available</h2>
            <p className="text-center text-white/80">
              This call has been retried. Let's take you to the latest attempt.
            </p>
          </div>

          <div className="p-8 text-center">
            <p className="text-gray-600">
              We've noticed there's a more recent version of this call. Viewing the latest attempt ensures you have the
              most up-to-date information and status.
            </p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="flex flex-col sm:flex-row justify-end gap-3 w-full">
          <button
            onClick={handleClose}
            className="px-6 py-2.5 text-gray-600 font-semibold rounded-full hover:bg-gray-100 transition-colors border border-gray-200"
          >
            Stay Here
          </button>
          <button
            onClick={handleNavigate}
            className="inline-flex justify-center items-center px-6 py-2.5 bg-purple-600 text-white font-semibold rounded-full transition-colors gap-2 hover:bg-purple-700"
          >
            View Latest Call
            <NavArrowRight className="w-5 h-5" />
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}
